// Video Button — hands its embed to the shared lightbox
// (resources/views/partials/video-lightbox.twig).
document.querySelectorAll("[data-cg-video-button]").forEach((button) => {
  const root = button.closest("[id^='components-video-button-block']");
  const tpl = root && root.querySelector("template.cg-video-button-embed");
  if (!tpl) return;

  button.addEventListener("click", () => {
    window.dispatchEvent(
      new CustomEvent("cg-video-lightbox", {
        detail: { html: tpl.innerHTML, label: button.textContent.trim() || "Video" },
      })
    );
  });
});
